import { SVGProps } from 'react'

const SvgDropdownArrowGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.90941 0.968109L4.99941 3.87811L2.08941 0.968109C1.94593 0.84524 1.76137 0.781035 1.57262 0.788326C1.38386 0.795617 1.2048 0.873866 1.07123 1.00744C0.937662 1.14101 0.859413 1.32006 0.852122 1.50882C0.844831 1.69758 0.909036 1.88213 1.03191 2.02561L4.47441 5.46811C4.61493 5.6078 4.80502 5.6862 5.00316 5.6862C5.20129 5.6862 5.39138 5.6078 5.53191 5.46811L8.97441 2.02561C9.11409 1.88509 9.1925 1.695 9.1925 1.49686C9.1925 1.29872 9.11409 1.10863 8.97441 0.968109C8.83195 0.829208 8.64087 0.751465 8.44191 0.751465C8.24294 0.751465 8.05186 0.829208 7.90941 0.968109Z"
      fill={props.fill ?? '#919191'}
    />
  </svg>
)

export default SvgDropdownArrowGrey
